module.exports = __webpack_public_path__ + "static/img/06hard.c78d5bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/09startTrain/06hard.png
// module id = X+pQ
// module chunks = 0